// src/refs.ts
import { isFunction } from "@chakra-ui/utils";

function assignRef(ref, value) {
  if (ref == null) return;

  if (isFunction(ref)) {
    ref(value);
    return;
  }

  try {
    ref.current = value;
  } catch (error) {
    throw new Error("Cannot assign value '".concat(value, "' to ref '").concat(ref, "'"));
  }
}

function mergeRefs() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }

  return function (node) {
    refs.forEach(function (ref) {
      return assignRef(ref, node);
    });
  };
} // src/context.ts


import { createContext as createReactContext, useContext as useReactContext } from "react";

function createContext() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$strict = options.strict,
      strict = _options$strict === void 0 ? true : _options$strict,
      _options$errorMessage = options.errorMessage,
      errorMessage = _options$errorMessage === void 0 ? "useContext: `context` is undefined. Seems you forgot to wrap component within the Provider" : _options$errorMessage,
      name = options.name;
  var Context = createReactContext(void 0);
  Context.displayName = name;

  function useContext() {
    var _a;

    var context = useReactContext(Context);

    if (!context && strict) {
      var error = new Error(errorMessage);
      error.name = "ContextError";
      (_a = Error.captureStackTrace) == null ? void 0 : _a.call(Error, error, useContext);
      throw error;
    }

    return context;
  }

  return [Context.Provider, useContext, Context];
} // src/children.ts


import { Children, isValidElement } from "react";

function getValidChildren(children) {
  return Children.toArray(children).filter(function (child) {
    return isValidElement(child);
  });
}

export { assignRef, createContext, getValidChildren, mergeRefs };